module.exports = __webpack_public_path__ + "img/mauritius.f24ebb5.webp";